export const fetcher = <T>(url: string, options?: RequestInit) => async () => {
    const response = await fetch(url, options);
    const contentType = response.headers.get('content-type') || '';

    if (!response.ok) {
        console.error(`${response.status} ${response.statusText} at ${url}`);
        return Promise.reject(response);

        // Currently only support JSON
    } else if (!contentType.includes('application/json')) {
        throw Error(`Content type ${contentType} handling not implemented`);
    }

    const data: T = await response.json();

    return data;
};
